/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne Swagger
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 4bcfc99b (Thu Mar  7 14:01:07 UTC 2024)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
import {
  EnrollmentDashboard,
  EnrollmentDashboardFromJSON,
  EnrollmentDashboardToJSON,
  EnrollmentInviteDashboard,
  EnrollmentInviteDashboardFromJSON,
  EnrollmentInviteDashboardToJSON,
  LicensingDue,
  LicensingDueFromJSON,
  LicensingDueToJSON,
  ProgramDashboard,
  ProgramDashboardFromJSON,
  ProgramDashboardToJSON,
} from './'

/**
 * Dashboard information for directors
 * @export
 * @interface FetchDashboardResponseDirectorDashboard
 */
export interface FetchDashboardResponseDirectorDashboard {
  /**
   * Enrollments in programs that the director directs.
   * @type {Array<EnrollmentDashboard>}
   * @memberof FetchDashboardResponseDirectorDashboard
   */
  outstandingEnrollments?: Array<EnrollmentDashboard>
  /**
   * Enrollment invites that director has access.
   * @type {Array<EnrollmentInviteDashboard>}
   * @memberof FetchDashboardResponseDirectorDashboard
   */
  outstandingInvitations?: Array<EnrollmentInviteDashboard>
  /**
   * Programs that director directs.
   * @type {Array<ProgramDashboard>}
   * @memberof FetchDashboardResponseDirectorDashboard
   */
  myPrograms?: Array<ProgramDashboard>
  /**
   *
   * @type {LicensingDue}
   * @memberof FetchDashboardResponseDirectorDashboard
   */
  licensing?: LicensingDue
}

export function FetchDashboardResponseDirectorDashboardFromJSON(
  json: any
): FetchDashboardResponseDirectorDashboard {
  return FetchDashboardResponseDirectorDashboardFromJSONTyped(json, false)
}

export function FetchDashboardResponseDirectorDashboardFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FetchDashboardResponseDirectorDashboard {
  if (json === undefined || json === null) {
    return json
  }
  return {
    outstandingEnrollments: !exists(json, 'outstandingEnrollments')
      ? undefined
      : (json['outstandingEnrollments'] as Array<any>).map(
          EnrollmentDashboardFromJSON
        ),
    outstandingInvitations: !exists(json, 'outstandingInvitations')
      ? undefined
      : (json['outstandingInvitations'] as Array<any>).map(
          EnrollmentInviteDashboardFromJSON
        ),
    myPrograms: !exists(json, 'myPrograms')
      ? undefined
      : (json['myPrograms'] as Array<any>).map(ProgramDashboardFromJSON),
    licensing: !exists(json, 'licensing')
      ? undefined
      : LicensingDueFromJSON(json['licensing']),
  }
}

export function FetchDashboardResponseDirectorDashboardToJSON(
  value?: FetchDashboardResponseDirectorDashboard | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    outstandingEnrollments:
      value.outstandingEnrollments === undefined
        ? undefined
        : (value.outstandingEnrollments as Array<any>).map(
            EnrollmentDashboardToJSON
          ),
    outstandingInvitations:
      value.outstandingInvitations === undefined
        ? undefined
        : (value.outstandingInvitations as Array<any>).map(
            EnrollmentInviteDashboardToJSON
          ),
    myPrograms:
      value.myPrograms === undefined
        ? undefined
        : (value.myPrograms as Array<any>).map(ProgramDashboardToJSON),
    licensing: LicensingDueToJSON(value.licensing),
  }
}
